<template>
    <div class="app-footer-container">
        <div class="link-container" v-for="link in legallinks" :key="link.ID">
            <a class="link" :href="link.Link" target="_blank">{{ link.Name }}</a>
        </div>

        <LanguageChangerFlat />
    </div>
</template>

<script>
import LanguageChangerFlat from '@elements/LanguageChangerFlat.vue'

export default {
    name: "app-footer",
    inject: ["systemConfig"],
    computed: {
        legallinks() {
            const availablelinks = this.systemConfig.linklist
            const idprivacy = this.systemConfig.configuration?.IDLinkDatenschutz
            const idimprint = this.systemConfig.configuration?.IDLinkImpressum

            return availablelinks.filter(entry => (entry.ID === idprivacy || entry.ID === idimprint))
        }
    },
    components: { 
        LanguageChangerFlat
    }
}
</script>

<style lang="scss" scoped>
.app-footer-container {
    flex-direction: row;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    background-color: #fff;
    box-shadow: 0 2px 8px #00000022;
    z-index: 999;

    > .link-container {
        padding: 0 10px;

        &:not(:last-child) {
            border-right: 1px solid #999;
        }

        > .link {
            text-decoration: none;
            color: #064A6C;
        }
    }
}
</style>